export default {
   tmpBackgroundColor: '#eef0f2',
   tmpContentLineColor: '#eee',
   tmpMainMenuBackgroundColor: '#0e1624',
   tmpMainMenuBorderColor: '#000',
   tmpMainMenuButtonActiveBackgroundColor: '#141d2e',
   tmpMainMenuButtonTextColor: '#d0dce3'
}
